module.exports = __webpack_public_path__ + "static/soarbanner-23be0cf92a5002b944e0575109a0c9a0.png";